import { api } from "@/services/api";
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
  middleware: (m) => m().concat(api.middleware),
  reducer: { [api.reducerPath]: api.reducer },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
